import { apiService } from "./apiService";

export interface IUploadSearchImageReq {
    searchId: string,
    base64: string,
    provider: string
}

export interface ISearchImageReq {
    key: string,
    searchId: string,
    provider: string,
    email: string,
    agencyCode: string,
    photoId?: string
}

export const AdhocService = {
    searchByImage: (settings: ISearchImageReq) => {
        return apiService.post('/api/adhoc', { search: settings }).then(response => {
            return response.data;
        });
    },
    uploadImage: (settings: IUploadSearchImageReq) => {
        return apiService.post('/api/adhoc/image', { search: settings }).then(response => {
            return response.data && response.data.success ? response.data : false;
        })
    }
}


// WEBPACK FOOTER //
// ./src/share/services/adhoc.ts